import { CountryCode } from '../countryCodes'

const languages: ILanguages = {
  /* eslint-disable @typescript-eslint/camelcase */
  bg: 'български',
  cz: 'Český',
  de: 'Deutsch',
  el: 'Ελληνικά',
  en: 'English',
  es: 'Español',
  fil: 'Filipino',
  fr: 'Français',
  hr: 'Hrvatski',
  hu: 'Madžarski',
  in: 'Bahasa Indonesia',
  it: 'Italiano',
  ja: '日本の',
  ko: '한국의',
  ms: 'Bahasa Melayu',
  pl: 'Polski',
  pl_PL: 'Polski',
  pt: 'Português',
  pt_BR: 'Brasileiro',
  ro: 'Română',
  ru: 'Русский',
  se: 'Svenska',
  th: 'ไทย',
  tr: 'Türkçe',
  uk: 'Українська',
  /* eslint-enable */
}

export default function(lng: CountryCode): string {
  return languages[lng]
}

type ILanguages = { [key in CountryCode]?: string }
